import { render, staticRenderFns } from "./WorkDataTable.vue?vue&type=template&id=d1a348de&scoped=true"
import script from "./WorkDataTable.vue?vue&type=script&lang=js"
export * from "./WorkDataTable.vue?vue&type=script&lang=js"
import style0 from "./WorkDataTable.vue?vue&type=style&index=0&id=d1a348de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a348de",
  null
  
)

export default component.exports